<mat-card class="upload-container">
    <mat-card-header>
      <mat-card-title>Upload Agreement Document</mat-card-title>
      <mat-card-subtitle>PDF files only - Maximum file size: 25 MB</mat-card-subtitle>
    </mat-card-header>
    
    <mat-card-content>
      <div 
        class="drop-zone" 
        [class.active]="isDragging" 
        [class.error]="fileSizeError || fileTypeError"
        (dragover)="onDragOver($event)" 
        (dragleave)="onDragLeave($event)" 
        (drop)="onDrop($event)"
      >
        <mat-icon>picture_as_pdf</mat-icon>
        <p>Drag and drop PDF document here</p>
        <p>or</p>
        <button mat-raised-button color="primary" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon> Browse Files
        </button>
        <small class="file-limit-text">PDF files only (Max: 25 MB)</small>
      </div>
      
      <input 
        #fileInput
        type="file" 
        hidden
        (change)="onFileSelected($event)" 
        accept=".pdf"
      >
      <mat-error *ngIf="fileTypeError" class="file-type-error">
        <mat-icon>error</mat-icon>
        {{ fileTypeError }}
      </mat-error>
      
      <mat-error *ngIf="fileSizeError" class="file-size-error">
        <mat-icon>error</mat-icon>
        {{ fileSizeError }}
      </mat-error>
      
      <div *ngIf="(selectedFile$ | async) as selectedFile" class="file-info">
        <mat-icon>picture_as_pdf</mat-icon>
        <div class="file-details">
          <span class="file-name">{{ selectedFile.name }}</span>
          <small class="file-size">{{ formatFileSize(selectedFile.size) }}</small>
        </div>
        <button mat-icon-button color="warn" (click)="clearFile()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      
      <mat-progress-bar 
        *ngIf="(uploadProgress$ | async) !== null" 
        [value]="uploadProgress$ | async" 
        mode="determinate"
      ></mat-progress-bar>
      
      <mat-error *ngIf="(uploadError$ | async) as error">
        {{ error }}
      </mat-error>
      
      <div *ngIf="(uploadComplete$ | async)" class="success-message">
        <mat-icon>check_circle</mat-icon> Document uploaded successfully!
      </div>
    </mat-card-content>
    
    <mat-card-actions align="end">
      <button 
        mat-raised-button 
        color="accent" 
        (click)="uploadFile()" 
        [disabled]="!(selectedFile$ | async) || (isUploading$ | async) || fileSizeError || fileTypeError"
      >
        <mat-icon>cloud_upload</mat-icon> Upload
      </button>
    </mat-card-actions>
  </mat-card>